import { combineReducers } from 'redux';

import { API_REQ_ACTION_TYPES } from 'api/actions';
import { ProcessGeneral } from 'api/endpoints/processes';

export interface ProcessState {
  list: Nullable<ProcessGeneral[]>;
  total: Nullable<number>;
}

const process = combineReducers<ProcessState>({
  list(
    state = null,
    { type, payload }: { type: string; payload: DataWithTotal<ProcessGeneral> }
  ) {
    switch (type) {
      case API_REQ_ACTION_TYPES.PROCESSES.GET_ALL.SUCCESS:
        return payload ? payload.data : null;
      default:
        return state;
    }
  },
  total(
    state = null,
    { type, payload }: { type: string; payload: DataWithTotal<ProcessGeneral> }
  ) {
    switch (type) {
      case API_REQ_ACTION_TYPES.PROCESSES.GET_ALL.SUCCESS:
        return payload ? payload.total : null;
      default:
        return state;
    }
  },
});

export default process;
